/* ==========================================================================
   dg-artist-index.js — films and bios for the artist spotlights on /collections

   This page can hold a dozen artists, so a dozen films. Liquid exposes only the 1080p mp4
   for these product videos, so each one is heavy — everything below exists to make sure a
   visitor only ever pays for the one or two they are actually looking at:

     - nothing is fetched under Data Saver or on a 2g connection
     - nothing is fetched until the window has loaded
     - a film's src is attached the first time its panel reaches the viewport, and the
       video is paused the moment it leaves

   Each panel keeps a real <img> poster underneath, so the page is complete in every one of
   the cases above where no video ever arrives.

   Second job: the "About the artist" button swaps the truncated bio for the full one.
   Rendered as a <button> and wired here, so with scripting off the short bio simply stands
   and no dead control is shown.
   ========================================================================== */

(function () {
  'use strict';

  /* --- bios -------------------------------------------------------------- */

  var buttons = document.querySelectorAll('[data-dgx-more]');

  for (var b = 0; b < buttons.length; b++) {
    (function (button) {
      var card = button.closest ? button.closest('.dgx') : null;
      if (!card) return;

      var shortBio = card.querySelector('[data-dgx-bio]');
      var fullBio = card.querySelector('[data-dgx-bio-full]');
      if (!shortBio || !fullBio) {
        button.hidden = true;
        return;
      }

      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
        shortBio.hidden = !open;
        fullBio.hidden = open;
        button.textContent = open ? 'About the artist' : 'Show less';
      });
    })(buttons[b]);
  }

  /* --- films ------------------------------------------------------------- */

  var panels = document.querySelectorAll('[data-dgx-film]');
  if (!panels.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var net = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (net) {
    if (net.saveData) return;
    if (/^(slow-)?2g$/.test(net.effectiveType || '')) return;
  }

  function start() {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        var video = entry.target.querySelector('video');
        if (!video) continue;

        if (entry.isIntersecting) {
          if (!video.getAttribute('src')) {
            var src = video.getAttribute('data-dgx-film-src');
            if (src) video.setAttribute('src', src);
          }
          var attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(function () {});
          entry.target.classList.add('is-playing');
        } else {
          video.pause();
          entry.target.classList.remove('is-playing');
        }
      }
    }, { threshold: 0.25 });

    for (var p = 0; p < panels.length; p++) io.observe(panels[p]);
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
